import React from 'react';
import { useSelector } from 'react-redux';
import { selectLatestSheetInQueue } from '../../state/sheets/sheetSelectors';
import Sheets from '.';

const SheetLoader: React.FunctionComponent = () => {
  const latestSheet = useSelector(selectLatestSheetInQueue);
  if (!latestSheet) return null;

  const { sheetType, ...props } = latestSheet;
  const Component = Sheets[sheetType];
  if (!Component) throw new Error('Sheet not added in Sheets/index.ts');

  return <Component {...props} />;
};

export default SheetLoader;
